import { render, staticRenderFns } from "./UserSharingChips.vue?vue&type=template&id=7f35e4f2&scoped=true"
import script from "./UserSharingChips.vue?vue&type=script&lang=js"
export * from "./UserSharingChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f35e4f2",
  null
  
)

export default component.exports